import { Component } from '@angular/core';

@Component({
  selector: 'app-resolution',
  templateUrl: './resolution.component.html',
  styleUrl: './resolution.component.css',
})
export class ResolutionComponent {}
